import { ListHeartIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const LikedComment = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ListHeartIcon size={Sizes[size]} {...rest} color={fill} />;
};

LikedComment.displayName = 'LikedComment';
